import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ModalButton from '../../atomic/Buttons/ModalButton';
import SelectModal from '../Modals/SelectModal';

const SelectModalStyled = styled(SelectModal)`
  max-width: 600px;
  width: 70%;
  min-width: 300px;
`

const ModalButtonStyled = styled(ModalButton)`
  display: flex;
  margin-right: 20px;
  text-transform: none;
  max-width: 200px;
  max-height: 40px;
  min-width: 30px;
  overflow: hidden;
  white-space: nowrap;
  justify-content: flex-start;
  opacity: ${props => props.selected ? 1 : 0.5};
  color: ${props => props.selected ? '#1bd2cc' : 'white'};
  border: 1px solid ${props => props.selected ? '#1bd2cc' : 'white'};;
`

class Select extends Component {
  getValues = () => {
    const { text, value } = this.props;
    if (value.length <= 0) {
      return text;
    } else {
      return value.map(item => item.label).join(', ');
    }
  }

  updateValue = value => {
    const { onChange } = this.props;
    onChange(value);
  }

  render() {
    const {
      options,
      multiple,
      header,
      value,
      ...other
    } = this.props;

    return (
      <ModalButtonStyled
        selected={value.length > 0}
        modalComponent={(
          <SelectModalStyled
            header={header}
            options={options}
            multiple={multiple}
            defaultValue={value}
            onSubmit={this.updateValue}
            {...other}
          />
        )}
        {...other}
      >
        {this.getValues()}
      </ModalButtonStyled>
    )
  }
}

Select.propTypes = {
  onChange: PropTypes.func,
  options: PropTypes.array,
  value: PropTypes.array,
};

Select.defaultProps = {
  value: [],
};

export default Select;
